import { Ng2StateDeclaration } from '@uirouter/angular';
import { NavbarComponent } from './layouts';
import { AuthService } from './shared';

export function authorizeFn(auth) {
    auth.authorize();
}

export const appState: Ng2StateDeclaration = {
    name: 'app',
    abstract: true,
    views: {
        'navbar@': { component: NavbarComponent },
    },
    resolve: [
        {
            token: 'authorize',
            deps: [AuthService],
            resolveFn: authorizeFn,
        },
    ],
};



// WEBPACK FOOTER //
// ./src/app/app.state.ts